import { ActivityEntityName } from '@jms/model/entities';
import { getSchema, MergeField, MergeSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.BulkInvoiceJob,
    name: 'BulkInvoiceJobSchema',
})
export class BulkInvoiceJobMergeData {

    @MergeField()
    jobNumber: string;

    @MergeField({
        displayName: "Customer WO"
    })
    customerWO: string;

    @MergeField()
    type: string;

    @MergeField()
    description: string;

    @MergeField()
    addressName: string;

    @MergeField()
    contractors: string;

    @MergeField()
    resources: string;

    @MergeField()
    appointments: string;
}

export const BulkInvoiceJobMergeSchema = getSchema(BulkInvoiceJobMergeData);